import { Table } from "antd";
import Moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Actions from "../../components/Common/Actions";
import Pagination from "../../components/Common/CommonPagination";
import Deletepopup from "../../components/Modal/Deletepopup";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import CTAHeader from "./CTAHeader";
import scroll from "../../assets/webp/scroll.webp";

const CTAForm = () => {
  const [showDelete, setShowDelete] = useState({ id: "", status: false });
  const [loader, setLoader] = useState(true);

  const { id } = useParams();

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}cta-form/ctaformlist`,
      initialParams: {
        category: id,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler("cta-form", fetchData, setShowDelete);

  useEffect(() => {
    setLoader(true)
    fetchData();
  }, [pagination.skip, pagination.limit, id]);

  const getCategoryColumnTitle = (id) => {
    if (id === "retail-pharmacies") return "Pharmacy Name";
    if (id === "doctors") return "Special Category";
    return "Service Category";
  };

  const columns = (id, setShowDelete) => [
    {
      title: "S.No",
      dataIndex: "serial",
      render: (_text, _record, index) => index + 1,
      fixed: "left",
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 300,
      fixed: "left",
    },
    {
      title: getCategoryColumnTitle(id),
      dataIndex:
        id === "retail-pharmacies"
          ? "pharmacy_name"
          : id === "doctors"
            ? "special_category"
            : "service_category",
      width: 300,
      fixed: "left",
    },
    {
      title: "Location",
      dataIndex: "location",
      width: 300,
    },
    {
      title: "Pincode",
      dataIndex: "pincode",
    },
    {
      title: "Mobile No",
      dataIndex: "mobile",
    },
    {
      title: "Upload Time",
      dataIndex: "createdAt",
      render: (createdAt) => Moment(createdAt).format("DD MMMM YYYY LT"),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_text, record) => (
        <Actions
          isDelete={true}
          onClickDelete={() => setShowDelete({ id: record._id, status: true })}
        />
      ),
    },
  ];

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <>
      <div>
        <CTAHeader type="Form" />
        {!loader ? (
          <>
            <Table
              bordered
              dataSource={records}
              columns={columns(id, setShowDelete)}
              pagination={false}
              rowKey="_id"
              className="mx-3 pt-2 table-scrollable medicineList_table"
              scroll={{ x: "max-content" }}
            />
          </>
        ) : (
          <div className="d-flex justify-content-center">
            <img src={scroll} width={150} alt="loader" />
          </div>
        )}
      </div>
      <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
        <div className="border border-danger bg-bg-light px-2 py-1 rounded">
          Total {id}: {totalCount}
        </div>
        {totalCount > pagination.limit && (
          <Pagination
            skip={pagination.skip}
            limit={pagination.limit}
            total={totalCount}
            onPageChange={(selected) => handlePageChange({ selected })}
          />
        )}
      </div>
      {showDelete.status && (
        <Deletepopup
          handleDelete={handleDelete}
          id={showDelete?.id}
          isCloseModalEnable={true}
          handleClose={() => setShowDelete({ id: "", status: false })}
        />
      )}
    </>
  );
};
export default CTAForm;
